<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getNavigatorType } from "@/utils/tool.js";
export default {
  name: "app",
  components: {},
  watch: {
    $route: function (to, from) {
      if (to.name.indexOf("_p") > 0 && !this.$pc) {
        console.log("移动端");
        this.$router.replace(to.name.split("_p")[0]);
        //电脑转手机端
        //域名为index_p去掉_p变成手机端index路由
        if (to.name == "index_p") {
          let str = to.name.split("_p")[0];
          let str2 = "/" + str;
          this.$router.push(str2);
        }
      } else if (to.name.indexOf("_p") < 0 && this.$pc) {
        console.log("pc端");
        //手机端转电脑
        //在路由尾巴添加_p变成电脑端
        this.$router.replace(to.name + "_p");
      }
    },
  },
  mounted() {
    let navigatorType = getNavigatorType();
    console.log(navigatorType);
    if (navigatorType === "Android") {
      document.querySelector("#app").style.paddingTop = "20px";
    }
  },
};
</script>

<style lang="scss">
@import "./common/common.css";
* {
  -webkit-text-size-adjust: none;
}
@media (min-width: 320px) {
  html {
    font-size: 50px;
  }
}
@media (min-width: 360px) {
  html {
    font-size: 56.25px;
  }
}
@media (min-width: 375px) {
  html {
    font-size: 58.59375px;
  }
}
@media (min-width: 384px) {
  html {
    font-size: 60px;
  }
}
@media (min-width: 400px) {
  html {
    font-size: 62.5px;
  }
}
@media (min-width: 414px) {
  html {
    font-size: 64.6875px;
  }
}
@media (min-width: 424px) {
  html {
    font-size: 66.25px;
  }
}
@media (min-width: 480px) {
  html {
    font-size: 75px;
  }
}
@media (min-width: 540px) {
  html {
    font-size: 84.375px;
  }
}
@media (min-width: 640px) {
  html {
    font-size: 100px;
  }
}
@media (min-width: 1024px) {
  html {
    font-size: 18px;
  }
}
@media (min-width: 1100px) {
  html {
    font-size: 20px;
  }
}
@media (min-width: 1280px) {
  html {
    font-size: 22px;
  }
}
@media (min-width: 1366px) {
  html {
    font-size: 24px;
  }
}
@media (min-width: 1440px) {
  body,
  html {
    font-size: 25px;
  }
}
@media (min-width: 1680px) {
  body,
  html {
    font-size: 28px;
  }
}
@media (min-width: 1920px) {
  body,
  html {
    font-size: 33px;
  }
}
html,
body,
#app {
  background: #fff;
}
body {
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}
</style>
